import {
  CallType,
  IntegrationFilter,
  LeadStatus,
} from '@callrail/inti/src/inti/proto/integration_filter';

export class IntegrationFilterXformer {
  public toProtoBinary(json: any): Uint8Array | null {
    if (!this.validateJSON(json)) {
      return null;
    }

    const xformedJSON = this.toProtoObj(json);
    const encoded = IntegrationFilter.encode(xformedJSON);
    return encoded.finish();
  }

  /**
   * Converts response body from inti to an array-like representation of binary
   * data buffer
   *
   * @param {ArrayBuffer} arrayBuffer
   * @return {Uint8Array}
   */
  public arrayBufferToProtoClass(arrayBuffer: ArrayBuffer): IntegrationFilter {
    const uint8Array = new Uint8Array(arrayBuffer);
    return IntegrationFilter.decode(uint8Array);
  }

  public validateJSON(json: any): boolean {
    const necessaryKeys: string[] = [
      'integration_id',
      'lead_status',
      'max_duration',
      'min_duration',
      'call_type',
      'tracker_ids',
      'tags',
      'id',
    ];

    const jsonKeys = Object.keys(json);

    return necessaryKeys.every((el) => jsonKeys.includes(el));
  }

  public toProtoObj(json: any): IntegrationFilter {
    return {
      integrationId: this.xformNumericType(json.integration_id),
      leadStatus: this.leadStatusEnumIndex(json.lead_status),
      maxDuration: this.xformNumericType(json.max_duration),
      minDuration: this.xformNumericType(json.min_duration),
      callType: this.callTypeEnumIndex(json.call_type),
      trackerMids: json.tracker_ids,
      tagIds: this.extractTagIds(json.tags),
      id: json.id,
      smsTypeList: [],
    };
  }

  public callTypeEnumIndex(enumKey: any): number | undefined {
    if (enumKey === null || enumKey === undefined) return undefined;

    const key = enumKey.toUpperCase();
    return parseInt(CallType[key], 10);
  }

  private leadStatusEnumIndex(enumKey: any): number | undefined {
    if (enumKey === null || enumKey === undefined) return undefined;

    const key = enumKey.toUpperCase();
    return parseInt(LeadStatus[key], 10);
  }

  private xformNumericType(value): number | undefined {
    if (value === null) return undefined;

    return value;
  }

  private extractTagIds(tags: any[]): number[] {
    return tags.map((el) => el.id);
  }
}
